// extracted by mini-css-extract-plugin
module.exports =  {"status":"_02712f2b3b--status--laM86","red":"_02712f2b3b--red--N95RP","green":"_02712f2b3b--green--OoKyw"};